export const homeRoutes = {
    app:  { index: (): string => '/' },
};
